import { animeLibrary } from './animelibrary.js';
import { animeLeftRightSlide } from './animeleftrightslide.js';

import { animeHoverPopup } from './animehoverpopup.js';
import { animeCardflip } from './animecardflip.js';

import { controlCommonAreas } from './controlcommonareas.js';
import { controlModals } from './controlmodals.js';

import { controlISI } from './controlisi.js';
import { controlMenu } from './controlmenu.js';
import { controlFilterVideos } from './controlfiltervideolibrary.js';
import { controlVideoShadowbox } from './controlvideoshadowbox.js';

// import '../../../node_modules/video.js/dist/video-js.css'

const debug = true;

animeLibrary(debug)
animeLeftRightSlide(debug)
animeHoverPopup(debug)
animeCardflip(debug)

controlCommonAreas(debug)
controlISI(debug)
controlMenu(debug)
controlFilterVideos(debug)
controlVideoShadowbox(debug)
controlModals(debug)